import React from 'react';

import {Modal, message , Tag} from 'antd';

import moment from 'moment';

import fetch from './../fetch';
import utils from './../../utils';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},
    {key:'name', label: '文件名称'},
    {key:'fullPath', label: '文件路径'},
    // {key:'fileNumber', label: '文件字号'},
    // {key:'publishOrgName', label: '发文部门'},
    {key:'publishDate', label: '发布日期', render: (value)=> moment(new Date(value)).format('YYYY/MM/DD')},
    {key:'realName', label: '上传人'},
    {key:'approvalStatu', label: '审核状态',render : (val)=> {
        if(val === 1) {
            return <Tag color='purple'>待审核</Tag>
        } else if(val === 2) {
            return <Tag color='green'>审核通过</Tag>
        }else if(val === 3) {
            return <Tag color='red'>审核不通过</Tag>
        }
    } },
    {key:'termName', label: '所属学期/学年'},
    {type:'action', label: '操作', values: ['read', 'down', 'file','video','image']},
]);





/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100, }) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}');
    const account = session.account;

    // const defaultsParams = {
    //     bgTermId: account.termId,
    //     endTermId: account.termId
    // };
    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)

    return fetch.post('reviewfilemanager/list?' + params.join('&'), keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}


/**
 * @method upload
 * @param {object} [keywords]
 * @return {promise}
 */
const upload = (keywords = {}) => {
    return fetch.post('reviewfilemanager/upload', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('reviewfilemanager/remove', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const exist = (id) => {
    return fetch.post('reviewfilemanager/exist/'+ id)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.selections = [];
                        DataGrid.refresh();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'file'+ url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = (params) => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        return fetch.post('reviewfilemanager/update', params);
    }
}

const getSelection =() => {
    return DataGrid.selections;
}

export default {
    querySearch,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    remove,
    upload,
    exist,
    getSelection
}